// extracted by mini-css-extract-plugin
module.exports = {"splitter":"ObjectsFilterMobile_splitter__D9wcI","actions":"ObjectsFilterMobile_actions__h8NlG"};